import { render } from "./Home.vue?vue&type=template&id=fcf50590&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=fcf50590&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gjf1611\\code\\private\\planet-c\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf50590"]])

export default __exports__